import { Organization } from "generated/graphql";
import React, { FC } from "react";
import { Avatar } from "react-toolbox/lib/avatar";

export interface OrgIconProps {
    readonly organization: Pick<Organization, "logoUrl" | "name">;
}

const OrgIcon: FC<OrgIconProps> = (props: OrgIconProps) => {
    const { organization } = props;

    if (organization) {
        if (organization.logoUrl) {
            return <Avatar image={organization.logoUrl} />;
        } else {
            return <Avatar title={props.organization.name} />;
        }
    } else {
        return <Avatar image="/img/xapp-logo-teal.svg" />;
    }
};

export { OrgIcon };
